export const manufacturingStages = [
  {
    step: "01",
    id: "cutting",
    title: "RAW FABRIC & PRECISION CUTTING",
    shortTitle: "CUTTING",
    heading: "PRECISION CUTTING",
    subheading: "Where the journey begins with exact dimensional accuracy.",
    description: "High-grade indigo cotton fabric rolls are inspected, unrolled, and mapped against master production markers. Laser and precision mechanical blades slice panels with millimeter accuracy to ensure perfect fit symmetry.",
    details: [
      "Automated computerized pattern layout",
      "Grainline alignment and shrinkage compensation",
      "Multi-ply precision cutter calibration"
    ],
    image: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?auto=format&fit=crop&w=1200&q=80",
    badge: "STAGE 01 — PREPARATION & CUTTING"
  },
  {
    step: "02",
    id: "printing",
    title: "BRANDING & PATTERN PRINTING",
    shortTitle: "PRINTING",
    heading: "PRINTING & EMBELLISHMENT",
    subheading: "Details that give every collection its distinct brand identity.",
    description: "Specialized screen, rotary, and pigment printing methods apply pocket liner graphics, interior sizing prints, and distinctive care branding directly onto cut denim panels prior to assembly.",
    details: [
      "Eco-compliant pigment inks",
      "High-durability pocket bag prints",
      "Custom brand logo placement"
    ],
    image: "https://images.unsplash.com/photo-1607344645866-009c320c5ab8?auto=format&fit=crop&w=1200&q=80",
    badge: "STAGE 02 — IDENTITY & PRINT"
  },
  {
    step: "03",
    id: "stitching",
    title: "STRUCTURAL SEAM STITCHING",
    shortTitle: "STITCHING",
    heading: "HEAVY-DUTY STITCHING",
    subheading: "Precision in every seam and stress point.",
    description: "Skilled operators utilize twin-needle lap seamers and heavy-duty bar-tack machines to join front/back panels, coin pockets, waistbands, and belt loops using high-tenacity poly-core threads.",
    details: [
      "Chain-stitch hem construction",
      "Reinforced stress bar-tacks",
      "Heavy-duty pocket rivets"
    ],
    image: "https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?auto=format&fit=crop&w=1200&q=80",
    badge: "STAGE 03 — CRAFT ASSEMBLY"
  },
  {
    step: "04",
    id: "washing",
    title: "LAUNDRY & WASH TREATMENT",
    shortTitle: "WASHING",
    heading: "ARTISAN WASHING",
    subheading: "Finishing denim with the unique character of the collection.",
    description: "Garments enter sustainable ozone, enzyme, and pumice washing drums to soften fabric feel, highlight indigo contrast, and achieve controlled shade variations with minimal water consumption.",
    details: [
      "Water-saving ozone processing",
      "Hand laser whiskering & scraping",
      "Controlled shade matching"
    ],
    image: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?auto=format&fit=crop&w=1200&q=80",
    badge: "STAGE 04 — LAUNDRY & WASH"
  },
  {
    step: "05",
    id: "finishing",
    title: "HARDWARE & TRIM FINISHING",
    shortTitle: "FINISHING",
    heading: "TRIM & DETAIL FINISHING",
    subheading: "Attention to the hardware details that complete the garment.",
    description: "Precision automatic presses attach oxidized brass shanks, rivets, leather waist patches, and care labels. Buttonholes are keyholed and trimmed to exact tension specs.",
    details: [
      "Heavy-duty metal hardware insertion",
      "Genuine leather / Jacron patch application",
      "Thread trimming and steam pressing"
    ],
    image: "https://images.unsplash.com/photo-1582552938357-32b906df40cb?auto=format&fit=crop&w=1200&q=80",
    badge: "STAGE 05 — TRIM & HARDWARE"
  },
  {
    step: "06",
    id: "quality",
    title: "MULTI-POINT QUALITY CONTROL",
    shortTitle: "QUALITY CONTROL",
    heading: "QUALITY INSPECTION",
    subheading: "Every detail deserves rigorous technical inspection.",
    description: "Inspectors evaluate every finished unit against measurement charts, seam pull resistance, shade consistency, and metal detection to guarantee standard compliance before bundling.",
    details: [
      "100% garment needle scan",
      "Dimension & measurement verification",
      "Color shade sorting"
    ],
    image: "https://images.unsplash.com/photo-1565084888279-aca607ecce0c?auto=format&fit=crop&w=1200&q=80",
    badge: "STAGE 06 — COMPLIANCE & QC"
  },
  {
    step: "07",
    id: "packing",
    title: "EXPORT PACKAGING & BUNDLING",
    shortTitle: "PACKING",
    heading: "PACKED FOR THE JOURNEY",
    subheading: "Prepared for corporate and international sourcing logistics.",
    description: "Garments are neatly folded, polybagged, silica protected, and packed into heavy double-wall export cartons with barcode indexing for seamless customs and warehouse entry.",
    details: [
      "Moisture-proof individual polybags",
      "Assorted size ratio master cartons",
      "Barcode & shipping mark labeling"
    ],
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80",
    badge: "STAGE 07 — LOGISTICS READY"
  },
  {
    step: "08",
    id: "global",
    title: "READY FOR GLOBAL MARKETS",
    shortTitle: "GLOBAL READY",
    heading: "READY FOR GLOBAL MARKETS",
    subheading: "From fabric to finished product, built for international trade.",
    description: "Consignments are staged for container loading, ready to be dispatched to ports and buyers worldwide. Contact our team to initiate your volume order.",
    details: [
      "Port-ready export documentation",
      "Dependable dispatch schedules",
      "Dedicated account manager"
    ],
    image: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1200&q=80",
    badge: "STAGE 08 — INTERNATIONAL DISPATCH"
  }
];
